import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { BetterWay } from './components/BetterWay';
import { BeforeAfter } from './components/BeforeAfter';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InstantAccess } from './components/InstantAccess';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-cream" data-id="element-0" data-mp="23w4fq47h1a2f">
      <header className="sticky top-0 z-40" data-id="element-1" data-mp="23v2rey1g2r2r">
        <CountdownBar data-id="element-2" data-mp="3ik7e6ay3c1o0" />
      </header>
      <main data-id="element-3" data-mp="3ij65ue8glt9z">
        <Hero data-id="element-4" data-mp="3ijpbavgxap74" />
        <StatsBar data-id="element-5" data-mp="3ihuyk4ft23e4" />
        <BetterWay data-id="element-6" data-mp="3mlj6io8cn0zw" />
        <BeforeAfter data-id="element-7" data-mp="3mkrdnl64zhdb" />
        <Recognize data-id="element-8" data-mp="3mk85gw6ag7ch" />
        <WhatsInside data-id="element-9" data-mp="3mjq45l4rr2xp" />
        <InstantAccess data-id="element-10" data-mp="3rc9f0ac2njyt" />
        <Bonuses data-id="element-11" data-mp="3rbrc4uuwm7hx" />
        <Offer data-id="element-12" data-mp="3rdarmj8qkein" />
        <Guarantee data-id="element-13" data-mp="3rcswjpxt86cb" />
        <Testimonials data-id="element-14" data-mp="3recctgjguhe3" />
        <FAQ data-id="element-15" data-mp="5otf64sd496" />
        <FinalCTA data-id="element-16" data-mp="6htxpd5ixiv" />
      </main>
      <Footer data-id="element-17" data-mp="5gel8p3rovc" />
    </div>;
}